export default __webpack_public_path__ + "static/media/expert-waiting-gif.0ae69980.gif";